import { Checkbox, Box } from '@mui/material';
import React from 'react';

import { fetchIcon } from '../../assets/icons/icons';

interface OwnProps {
  label?: string;
  rightElement?: any;
  checkboxes?: boolean;
  selected?: boolean;
  extra?: string;
  icon?: string;
}

const AutocompleteOption: React.FC<OwnProps> = (props) => {
  return (
    <Box
      component="li"
      width={'100%'}
      mr={2}
      mb={2}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      {...props}
    >
      {props.rightElement && (
        <Box height={'100%'} width="40px">
          {props.rightElement}
        </Box>
      )}
      {props.icon && fetchIcon(props.icon, 20)}

      <Box
        display="flex"
        height="100%"
        flex={1}
        flexDirection="column"
        ml={2}
        mr={2}
      >
        <Box
          height={props.extra ? '60%' : '100%'}
          display="flex"
          alignItems="center"
        >
          {props.label}
        </Box>
        {props.extra && <Box height={'40%'}>{props.extra}</Box>}
      </Box>
      {props.checkboxes && (
        <Box>
          <Checkbox
            checked={props.selected}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </Box>
      )}
    </Box>
  );
};

export default AutocompleteOption;
